var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.inputComponent,
    _vm._b(
      {
        ref: "input",
        tag: "component",
        staticClass: "vuTypeahead",
        on: { focus: _vm.onFocus },
        nativeOn: {
          keyup: function ($event) {
            return _vm.onKeyUp.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "addons",
              fn: function () {
                return [
                  _c(
                    _vm.p.dropdownComponent,
                    _vm._b(
                      {
                        tag: "component",
                        staticClass: "vuTypeahead__dropdown",
                        attrs: {
                          "parent-is-reference": "",
                          "as-block": "",
                          "as-list-box": "",
                        },
                        model: {
                          value: _vm.p.dropdownOpen,
                          callback: function ($$v) {
                            _vm.$set(_vm.p, "dropdownOpen", $$v)
                          },
                          expression: "p.dropdownOpen",
                        },
                      },
                      "component",
                      _vm.dropdownComponentProps,
                      false
                    ),
                    [
                      !_vm.p.noLoader && _vm.p.isWaitingForResolver
                        ? _c(
                            "li",
                            { staticClass: "vuTypeahead__dropdownLoader" },
                            [
                              _vm._t("loader", function () {
                                return [_vm._v(_vm._s(_vm.p.loadingLabel))]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t(
                        "items",
                        function () {
                          return _vm._l(
                            _vm.p.filteredListItems,
                            function (item) {
                              return _c(
                                _vm.p.dropdownItemComponent,
                                _vm._b(
                                  {
                                    key: item.label,
                                    tag: "component",
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.setValue(item)
                                      },
                                      keyup: function ($event) {
                                        return _vm.onDropdownKeyUp($event, item)
                                      },
                                    },
                                  },
                                  "component",
                                  _vm.dropdownItemComponentProps,
                                  false
                                ),
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(item.label) +
                                      "\n                "
                                  ),
                                ]
                              )
                            }
                          )
                        },
                        {
                          setValue: _vm.setValue,
                          items: _vm.p.filteredListItems,
                        }
                      ),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "component",
      _vm.inputComponentProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }